import SimpleSelect from "./SimpleSelect";
import SimpleText from "./SimpleText";
import SimpleTextarea from "./SimpleTextarea";
import SimpleRadioButton from "./SimpleRadioButton";

export const simpleAjaxForm = {
    data(){
        return {
            loading : false, //The ajax loading status for use in theme
            message : '',
            errors  : {},
            data    : {},
        }
    },
    methods: {
        submit(requestUri, method = 'post'){
            this.loading = true;

            this.errors = [];
            this.message = '';

            let action;

            let form = new FormData();
            form.append('_token', this.getCsrf());

            for ( let key in this.form ) {
                form.append(key, this.form[key]);
            }

            switch (method){
                case 'post':
                    action = this.axios.post(requestUri,this.form, this.config);
                break;
                case 'put':
                    action = this.axios.put(requestUri,this.form, this.config);
                break;
            }

            action.then(response => { //Runs on success
                this.data = response.data.data;
                this.successful(response.data.data);
                this.successfulToast();
            }).catch((error) => { //Runs on failure
                if(error.hasOwnProperty('response') && error.response.hasOwnProperty('data')){
                    this.message = error.response.data.message;
                    if(error.response.data.hasOwnProperty('errors')){
                        this.errors = error.response.data.errors;
                    }
                } else {
                    this.message = error.message;
                }
                this.failure();
                this.failureToast();
            }).then(()=>{ //Runs anyway
                this.loading = false;
            });
        },
        hasError(item){
            //Return true if there is a validation error for the field
            return typeof this.errors[item] != 'undefined';
        },
        feedbackHtml(item){
            //Return the errors html based on bootstrap4 validation if exists
            if(typeof this.errors[item] != 'undefined'){
                let outputHtml = '';
                for(let error in this.errors[item]){
                    outputHtml+= '<div class="invalid-feedback">'+this.errors[item][error]+'</div>';
                }
                return outputHtml;
            }
            return '';
        },
        successfulToast(){
            this.$moshaToast('با موفقیت ذخیره شد.' ,{
                position: 'top-left',
                type: 'success',
            });
        },
        successful(data){
            //Run in the component in successful status
        },
        failureToast(){
            this.$moshaToast(this.message,{
                position: 'top-left',
                type: 'danger',
            });
        },
        failure(){
            //Run in the component in failure status
        },
    },
    computed: {
        config() {
            return {

            }
        }
    },
    components: {SimpleText,SimpleTextarea,SimpleSelect,SimpleRadioButton}
}
export default class SimpleAjaxFormMixin {
}
